import { privateClient } from "../../configs/axiosConfig";

const orderingEndpoints = {
  create: "v1/orders",
  getAll: "v1/orders",
  getOrderById: (id) => `v1/orders/${id}`,
  update: "v1/orders/:id",
  delete: "v1/orders/:id",
  deleteAll: "v1/orders/deleteAll",

  // ✅ ADD THIS
  refund: (id) => `v1/orders/${id}/refund`,
};

const orderingApi = {
  /**
   * ✅ Create Order
   */
  createOrder: async (payload) => {
    try {
      const response = await privateClient.post(
        orderingEndpoints.create,
        payload,
      );

      return { response, err: null };
    } catch (err) {
      console.error("❌ Create order error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },

  /**
   * ✅ Get All Orders
   */
  getAllOrders: async () => {
    try {
      const response = await privateClient.get(orderingEndpoints.getAll);

      return { response, err: null };
    } catch (err) {
      console.error("❌ Get all orders error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },

  /**
   * ✅ Get Order By ID
   */
  getOrderById: async (id) => {
    try {
      const response = await privateClient.get(
        orderingEndpoints.getOrderById(id),
      );
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
  /**
   * ✅ Update Order (status, payment, etc.)
   */
  updateOrder: async ({ id, payload }) => {
    try {
      const endpoint = orderingEndpoints.update.replace(":id", id);

      const response = await privateClient.patch(endpoint, payload);

      return { response, err: null };
    } catch (err) {
      console.error("❌ Update order error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },

  /**
   * ✅ Delete Order
   */
  deleteOrderById: async ({ id }) => {
    try {
      const endpoint = orderingEndpoints.delete.replace(":id", id);

      const response = await privateClient.delete(endpoint);

      return { response, err: null };
    } catch (err) {
      console.error("❌ Delete order error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },

  /**
   * ✅ Delete All Orders
   */
  deleteAllOrders: async () => {
    try {
      const response = await privateClient.delete(orderingEndpoints.deleteAll);

      return { response, err: null };
    } catch (err) {
      console.error("❌ Delete all orders error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },

  updateOrderStatus: async ({ id, status }) => {
    try {
      const response = await privateClient.patch(`v1/orders/${id}/status`, {
        orderStatus: status,
      });

      return { response, err: null };
    } catch (err) {
      console.error("❌ Update status error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },

  /**
   * 💸 Refund Order
   */
  refundOrder: async ({ id, amount }) => {
    try {
      const response = await privateClient.patch(
        orderingEndpoints.refund(id),
        { amount }, // optional (for partial refund)
      );

      return { response, err: null };
    } catch (err) {
      console.error("❌ Refund order error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },
};

export default orderingApi;
